import {ACTION_CODE} from './_actionCode';
import {ActivitiesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'DELETE_ACTIVITY';

export async function deleteActivity(token = '', activityId: number | string) {
    try {
        LoggerService.logInfo('Action - deleteActivity - Start');

        const result = await ActivitiesService.deleteActivity(token, activityId);

        LoggerService.logInfo('Action - deleteActivity - End - Success');

        return ResultModel.newSuccessResult(result);
    }
    catch (error) {
        LoggerService.logInfo('Action - deleteActivity - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression de l\'activité',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
